module.exports = __webpack_public_path__ + "static/logo-e66969952d7d23385b2b3d00a4486944.svg";